import { QuestionType, type PlanI18nInput } from "@/lib/gql/__generated__/graphql";

import type { ProductPlanI18nFormModel } from "../../../../type";

type Props = {
	viewModel: ProductPlanI18nFormModel["ViewModel"];
};

export const viewModelToPlanInputConverter = ({ viewModel }: Props): PlanI18nInput => {
	const { hotelID, planID, lang, name, emailTemplateReservation, mainTarget, questions } = viewModel;

	const planInput: PlanI18nInput = {
		hotelID,
		planID,
		lang,

		name: name.value,
		mainTarget: mainTarget?.value ?? undefined,

		emailTemplateReservation: emailTemplateReservation
			? {
					atCreated: emailTemplateReservation.atCreated?.value,
					atUpdated: emailTemplateReservation.atUpdated?.value,
					atCin: emailTemplateReservation.atCin?.value,
					atCanceled: emailTemplateReservation.atCanceled?.value,
				}
			: undefined,

		questions: questions?.value?.map((item) => {
			return {
				questionID: item.questionID?.value ?? "",
				questionType: item.questionType?.value ?? QuestionType.Free,
				required: item.required?.value ?? false,

				question: item.question?.value ?? "",
				options: item.options?.value?.map((item) => item.value),
			};
		}),
	} satisfies PlanI18nInput;

	return planInput;
};
